<div [hidden]="!showLoader" class="progress-overlay">
  <spinner [message]="loading | translate"></spinner>
</div>
